import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { showMessageBar } from "../redux/slices/messageBarSlice";

// ---------------- Version Notifier Hook ----------------
export const useVersionNotifier = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const notify = () => {
      const pending = localStorage.getItem("pending-version");
      const shown = localStorage.getItem("pending-version-shown");

      if (!pending || pending === shown) return;

      localStorage.setItem("pending-version-shown", pending);

      dispatch(
        showMessageBar({
          variant: "info",
          message: "New version available",
          otherProps: {
            persist: true,
            action: (
              <button
                style={{
                  background: "rgba(255,255,255,0.15)",
                  border: "1px solid rgba(255,255,255,0.4)",
                  color: "#fff",
                  padding: "6px 12px",
                  borderRadius: 4,
                  fontWeight: 600,
                  cursor: "pointer",
                }}
                onClick={() => {
                  localStorage.setItem("app-version", pending);
                  localStorage.removeItem("pending-version");
                  localStorage.removeItem("pending-version-shown");
                  window.location.reload();
                }}
              >
                Refresh
              </button>
            ),
          },
        })
      );
    };

    // run once on mount
    notify();

    const handleStorageChange = (e) => {
      if (e.key === "pending-version") {
        notify();
      }
    };

    window.addEventListener("app-version-changed", notify); // Local trigger
    window.addEventListener("storage", handleStorageChange); // Cross-tab trigger

    return () => {
      window.removeEventListener("app-version-changed", notify);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [dispatch]);
};
